import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlarmDataSort } from '@models/alarm';

@Component({
    selector: 'app-alarm-table-header',
    templateUrl: './alarm-table-header.component.html',
    styleUrls: ['./alarm-table-header.component.scss'],
    standalone: false
})
export class AlarmTableHeaderComponent {
    @Output() onSortChanged = new EventEmitter<AlarmDataSort>();
    @Output() onSort = new EventEmitter();
    @Output() onRefresh = new EventEmitter();
    @Input() showRefresh: boolean = true;
    public sort: AlarmDataSort = AlarmDataSort.DESC;

    onOccurrenceTimeSortClicked() {
        this.flipOccurrenceTimeSort();
        this.emitSortChange();
    }

    flipOccurrenceTimeSort() {
        this.sort = this.sort === AlarmDataSort.DESC ? AlarmDataSort.ASC : AlarmDataSort.DESC;
    }

    emitSortChange() {
        this.onSortChanged.emit(this.sort);
    }

    emitSort() {
        this.onSort.emit();
    }

    emitRefresh() {
        this.onRefresh.emit();
    }
}
